"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useParentalChange;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _invariant = _interopRequireDefault(require("invariant"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.set"));

function useParentalChange(setValues, formValues) {
  var parentalChange = _react.default.useCallback(function (map) {
    return function (toChange) {
      (0, _invariant.default)(map && (0, _typeof2.default)(map) === 'object', 'FormikExtended.parentalChange require `map` to be an Object.');
      (0, _invariant.default)(toChange && (0, _typeof2.default)(toChange) === 'object', 'FormikExtended.parentalChange require toChange to be an Object.');
      var realToChange = Object.entries(toChange).reduce(function (res, _ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            mapKey = _ref2[0],
            value = _ref2[1];

        var nextRes = (0, _extends2.default)({}, res);

        if (map[mapKey]) {
          var _ref3 = typeof value !== 'function' ? [true, value] : function (fn) {
            var xr = fn((0, _lodash.default)(formValues, map[mapKey]), formValues);
            (0, _invariant.default)(Array.isArray(xr) && [1, 2].includes(xr.length), 'FormikExtended.parentalChange value function have to return tuple `[boolean] | [boolen, any]`. ' + 'Where first item indicates whether or not update parent value.');
            return xr;
          }(value),
              _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
              makeUpdate = _ref4[0],
              realValue = _ref4[1];

          if (makeUpdate) (0, _lodash2.default)(nextRes, map[mapKey], realValue);
        }

        return nextRes;
      }, {});

      if (Object.keys(realToChange).length !== 0) {
        setValues((0, _extends2.default)({}, formValues, {}, realToChange));
      }
    };
  }, [setValues, formValues]);

  return parentalChange;
}